/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* ------------------------------------------------------------
   商品ページ / Product page — 大画像を1枚だけ表示する
   Show one product image at a time; thumbnails switch it.
   表示制御は CSS 側（1008px 以上）。ここは状態管理のみ。
   Visibility is gated by CSS; this only manages state.
   ------------------------------------------------------------ */
(function () {
  function nvInitSwapGallery() {
    var gallery = document.querySelector('.Product__Gallery--withThumbnails');
    if (!gallery || gallery.getAttribute('data-nv-swap') === '1') { return; }

    var slideshow = gallery.querySelector('.Product__Slideshow');
    var thumbs = gallery.querySelectorAll('.Product__SlideshowNavImage');
    if (!slideshow || thumbs.length < 2) { return; }

    gallery.setAttribute('data-nv-swap', '1');
    gallery.classList.add('nv-swap');

    function nvShow(id) {
      var i;
      var cells = slideshow.querySelectorAll('.Carousel__Cell');
      for (i = 0; i < cells.length; i++) {
        if (cells[i].id === id) {
          cells[i].classList.add('nv-on');
        } else {
          cells[i].classList.remove('nv-on');
        }
      }
      for (i = 0; i < thumbs.length; i++) {
        var href = thumbs[i].getAttribute('href') || '';
        if (href.slice(1) === id) {
          thumbs[i].classList.add('is-selected');
        } else {
          thumbs[i].classList.remove('is-selected');
        }
      }
    }

    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function (e) {
        var id = (this.getAttribute('href') || '').slice(1);
        if (!document.getElementById(id)) { return; }
        e.preventDefault();
        nvShow(id);
      });
    }

    nvShow((thumbs[0].getAttribute('href') || '').slice(1));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nvInitSwapGallery);
  } else {
    nvInitSwapGallery();
  }
  document.addEventListener('shopify:section:load', nvInitSwapGallery);
})();
/* ------------------------------------------------------------
   商品ページ / Product page — 説明文を横タブに組み替える
   Rebuild the product description into horizontal tabs.
   WASABI SWITCH が出力する .lx-sec を class で振り分ける。
   Sections are sorted by class, not by heading text.
   ------------------------------------------------------------ */
(function () {
    var LANG = {
    ja: { heading:'商品詳細', detail:'詳細', size:'サイズ・仕様', condition:'コンディション', notes:'備考', warranty:'保証について',
          sumL:'基本情報', sumR:'コンディション', period:'保証期間', more:'すべての項目を見る', close:'閉じる', ranks:'ランク一覧を見る' },
    en: { heading:'Product details', detail:'Details', size:'Size & Specs', condition:'Condition', notes:'Notes', warranty:'Warranty',
          sumL:'Key specs', sumR:'Condition', period:'Warranty', more:'View all details', close:'Close', ranks:'View grading scale' },
    fr: { heading:'Détails du produit', detail:'Détails', size:'Taille et spécifications', condition:'État', notes:'Remarques', warranty:'Garantie',
          sumL:'Informations clés', sumR:'État', period:'Garantie', more:'Voir tous les détails', close:'Fermer', ranks:'Voir les grades' },
    es: { heading:'Detalles del producto', detail:'Detalles', size:'Tallas y especificaciones', condition:'Estado', notes:'Notas', warranty:'Garantía',
          sumL:'Datos principales', sumR:'Estado', period:'Garantía', more:'Ver todos los detalles', close:'Cerrar', ranks:'Ver escala de grados' },
    ko: { heading:'상품 상세', detail:'상세 정보', size:'사이즈·사양', condition:'컨디션', notes:'비고', warranty:'보증 안내',
          sumL:'기본 정보', sumR:'컨디션', period:'보증 기간', more:'모든 항목 보기', close:'닫기', ranks:'등급표 보기' },
    zh: { heading:'商品详情', detail:'商品详情', size:'尺寸·规格', condition:'品相', notes:'备注', warranty:'保修说明',
          sumL:'基本信息', sumR:'品相', period:'保修期', more:'查看全部项目', close:'收起', ranks:'查看成色等级表' }
  };
  var ORDER = ['detail', 'size', 'condition', 'notes', 'warranty'];
  /* 「詳細」タブの概要ブロック / Summary block for the detail tab
     各タブに配置済みの行からラベル名で拾い直して2カラムに組む。
     元の内容は動かさないので、各タブの表示はそのまま。
     Rows are picked by label from the tabs that already hold them
     and re-laid out in two columns. The originals are untouched. */
  var SUM_LABELS = ['管理番号','ブランド','型番','素材','ムーブメント','ケース','腕周り','サイズ','カラー','ハンドル高さ'];
  var SUM_MAX = 7;

  function nvTxt(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function nvSumRow(label, valueHtml) {
    var row = document.createElement('div');
    row.className = 'lx-row';
    var lb = document.createElement('span');
    lb.className = 'lx-lb';
    lb.textContent = label;
    var vl = document.createElement('span');
    vl.className = 'lx-vl';
    vl.innerHTML = valueHtml;
    row.appendChild(lb);
    row.appendChild(vl);
    return row;
  }

  function nvHead(text) {
    var p = document.createElement('p');
    p.className = 'nv-sum__h';
    p.textContent = text;
    return p;
  }

  function nvBuildSummary(panels, t) {
    var detail = panels.querySelector('[data-nv-panel="detail"]');
    if (!detail || detail.querySelector('.nv-sum')) { return; }
    var cond = panels.querySelector('[data-nv-panel="condition"]');

    var srcRows = panels.querySelectorAll('.lx-sec .lx-row');
    var picked = [];
    var used = {};
    var i, j, lb, vl;

    // ホワイトリスト順に拾う。括弧書きの2行目は概要では省く。
    // Pick in whitelist order; drop the second line of a value.
    for (i = 0; i < SUM_LABELS.length && picked.length < SUM_MAX; i++) {
      for (j = 0; j < srcRows.length; j++) {
        if (used[j]) { continue; }
        lb = srcRows[j].querySelector('.lx-lb');
        vl = srcRows[j].querySelector('.lx-vl');
        if (!lb || !vl || nvTxt(lb) !== SUM_LABELS[i]) { continue; }
        used[j] = 1;
        picked.push(nvSumRow(nvTxt(lb), vl.innerHTML.split(/<br\s*\/?>/i)[0]));
        break;
      }
    }

    // 翻訳版でラベルが一致しない場合は先頭から / Fallback for translated labels
    if (picked.length < 3) {
      picked = [];
      var base = detail.querySelectorAll('.lx-row');
      for (i = 0; i < base.length && i < SUM_MAX; i++) {
        lb = base[i].querySelector('.lx-lb');
        vl = base[i].querySelector('.lx-vl');
        if (lb && vl) {
          picked.push(nvSumRow(nvTxt(lb), vl.innerHTML.split(/<br\s*\/?>/i)[0]));
        }
      }
    }

    // 保証対象の商品のみ最終行に保証期間 / Warranty row only when covered
    var on = panels.querySelector('.nv-wr__row--on dd');
    if (on) { picked.push(nvSumRow(t.period, nvTxt(on))); }

    var sum = document.createElement('div');
    sum.className = 'nv-sum';

    var colL = document.createElement('div');
    colL.className = 'nv-sum__col';
    colL.appendChild(nvHead(t.sumL));
    var rowsBox = document.createElement('div');
    rowsBox.className = 'nv-sum__rows';
    for (i = 0; i < picked.length; i++) { rowsBox.appendChild(picked[i]); }
    colL.appendChild(rowsBox);

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'nv-sum__more';
    more.textContent = t.more + ' ＋';
    more.addEventListener('click', function () {
      var open = detail.classList.toggle('nv-sum-open');
      more.textContent = open ? (t.close + ' －') : (t.more + ' ＋');
    });
    colL.appendChild(more);

    var colR = document.createElement('div');
    colR.className = 'nv-sum__col';
    colR.appendChild(nvHead(t.sumR));

    if (cond) {
      var active = cond.querySelector('.lx-rnk tr.active');
      if (active) {
        var tds = active.querySelectorAll('td');
        var rank = document.createElement('div');
        rank.className = 'nv-sum__rank';
        var g = document.createElement('span');
        g.className = 'nv-sum__grade';
        g.textContent = nvTxt(tds[0]);
        var d = document.createElement('span');
        d.className = 'nv-sum__desc';
        d.textContent = tds[1] ? nvTxt(tds[1]) : '';
        rank.appendChild(g);
        rank.appendChild(d);
        colR.appendChild(rank);
      }

      var tbl = cond.querySelector('.lx-rnk');
      if (tbl) {
        var list = document.createElement('div');
        list.className = 'nv-sum__ranks';
        list.hidden = true;
        list.appendChild(tbl.cloneNode(true));
        var rbtn = document.createElement('button');
        rbtn.type = 'button';
        rbtn.className = 'nv-sum__more';
        rbtn.textContent = t.ranks + ' ＋';
        rbtn.addEventListener('click', function () {
          list.hidden = !list.hidden;
          rbtn.textContent = t.ranks + (list.hidden ? ' ＋' : ' －');
        });
        colR.appendChild(rbtn);
        colR.appendChild(list);
      }

      var cRows = cond.querySelectorAll('.lx-cond-box .lx-row');
      if (cRows.length) {
        var box = document.createElement('div');
        box.className = 'nv-sum__cond';
        for (i = 0; i < cRows.length; i++) { box.appendChild(cRows[i].cloneNode(true)); }
        colR.appendChild(box);
      }

      var cbox = cond.querySelector('.lx-cond-box');
      var note = cbox ? cbox.nextElementSibling : null;
      if (note && note.tagName === 'P') {
        var n = note.cloneNode(true);
        n.removeAttribute('style');
        n.className = 'nv-sum__note';
        colR.appendChild(n);
      }
    }

    sum.appendChild(colL);
    sum.appendChild(colR);
    detail.insertBefore(sum, detail.firstChild);
  }
  function nvBuildTabs() {
    var root = document.querySelector('[data-nv-tabs]');
    if (!root || root.getAttribute('data-nv-tabs-built') === '1') { return; }

    var src = root.querySelector('[data-nv-tabs-src]');
    if (!src) { return; }

    var secs = src.querySelectorAll('.lx-sec');
    if (!secs.length) { return; }

    root.setAttribute('data-nv-tabs-built', '1');

    var lx = src.querySelector('.lx') || src;
    var code = (document.documentElement.lang || 'ja').split('-')[0].toLowerCase();
    var t = LANG[code] || LANG.ja;

    var groups = {};
    var passedParts = false;
    var i, j, key;

    for (i = 0; i < secs.length; i++) {
      if (secs[i].querySelector('.lx-rnk')) {
        key = 'condition';
      } else if (secs[i].querySelector('.lx-notes')) {
        key = 'notes';
      } else if (secs[i].querySelector('.lx-parts')) {
        key = 'size';
        passedParts = true;
      } else if (i === 0) {
        key = 'detail';
      } else if (!passedParts) {
        key = 'size';
      } else {
        key = 'detail';
      }
      if (!groups[key]) { groups[key] = []; }
      groups[key].push(secs[i]);
    }

    var warranty = root.querySelector('[data-nv-tabs-warranty]');
    if (warranty) {
      warranty.removeAttribute('hidden');
      groups.warranty = [warranty];
    }

    var nav = document.createElement('div');
    nav.className = 'nv-tabs__nav';
    var panels = document.createElement('div');
    panels.className = 'nv-tabs__panels';
    var first = true;

    for (i = 0; i < ORDER.length; i++) {
      key = ORDER[i];
      if (!groups[key] || !groups[key].length) { continue; }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nv-tabs__tab' + (first ? ' is-active' : '');
      btn.setAttribute('data-nv-tab', key);
      btn.textContent = t[key] || key;
      nav.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'nv-tabs__panel' + (first ? ' is-active' : '');
      panel.setAttribute('data-nv-panel', key);
      for (j = 0; j < groups[key].length; j++) {
        panel.appendChild(groups[key][j]);
      }
      panels.appendChild(panel);

      first = false;
    }

        // PC は「詳細」タブで全項目をまとめて表示する（段組は CSS 側）
    // On desktop the "detail" tab shows every section at once
    if (panels.firstChild && panels.firstChild.getAttribute('data-nv-panel') === 'detail') {
      panels.classList.add('nv-tabs__panels--all');
    }

    lx.insertBefore(panels, lx.firstChild);
    lx.insertBefore(nav, panels);
    var head = document.createElement('div');
    head.className = 'nv-tabs__heading';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'nv-tabs__eyebrow';
    eyebrow.textContent = 'DETAILS';
    var htitle = document.createElement('h2');
    htitle.className = 'nv-tabs__title';
    htitle.textContent = t.heading || '';
    head.appendChild(eyebrow);
    head.appendChild(htitle);
    lx.insertBefore(head, nav);
    nvBuildSummary(panels, t);

    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.nv-tabs__tab');
      if (!b) { return; }
      var k = b.getAttribute('data-nv-tab');
      var tabs = nav.querySelectorAll('.nv-tabs__tab');
      var ps = panels.querySelectorAll('.nv-tabs__panel');
      var n;
      for (n = 0; n < tabs.length; n++) {
        tabs[n].classList.toggle('is-active', tabs[n] === b);
      }
           for (n = 0; n < ps.length; n++) {
        ps[n].classList.toggle('is-active', ps[n].getAttribute('data-nv-panel') === k);
      }
      panels.classList.toggle('nv-tabs__panels--all', k === 'detail');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nvBuildTabs);
  } else {
    nvBuildTabs();
  }
  document.addEventListener('shopify:section:load', nvBuildTabs);
})();
/* ------------------------------------------------------------
   商品ページ / Product page — 右カラム sticky の停止位置を再計算
   Recalculate where the sticky right column stops.
   theme.js は全画像が縦積みの状態で高さを測るため、
   1枚表示に切り替えた後は値が大きすぎる。測り直す。
   theme.js measures while every image is still stacked, so the
   value is far too large once only one image is shown.
   ------------------------------------------------------------ */
(function () {
  var MQ = '(min-width: 1008px)';

  function nvRecalcSticky() {
    if (!window.matchMedia(MQ).matches) { return; }

    var info = document.querySelector('.Product__Info');
    var aside = document.querySelector('.Product__Aside');
    if (!info || !aside) { return; }

    var wrap = info.closest('.Product__InfoWrapper');
    if (!wrap) { return; }

  // 右カラムの「下端」が aside の手前で止まるようにする。
    // テーマ既定の式は「上端」が aside の位置で止まる計算なので、
    // 全幅にした aside と重なってしまう。
    // Stop the BOTTOM of the column before the aside. The theme's
    // formula stops its TOP there, which overlaps a full-width aside.
    wrap.style.maxHeight = Math.max(0, aside.offsetTop - 40) + 'px';

    // テーマが付ける min-height は余白になるだけなので解除する
    // The min-height the theme sets is no longer needed here.
    aside.style.minHeight = '';
  }

  var timer = null;
  function nvRecalcSoon() {
    if (timer) { clearTimeout(timer); }
    timer = setTimeout(nvRecalcSticky, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nvRecalcSoon);
  } else {
    nvRecalcSoon();
  }

  window.addEventListener('load', nvRecalcSoon);
  window.addEventListener('resize', nvRecalcSoon);

  // サムネイル切替やタブ切替で高さが変わるため
  // Height changes when a thumbnail or a tab is clicked
  document.addEventListener('click', function (e) {
    if (e.target.closest('.Product__SlideshowNavImage, .nv-tabs__tab')) {
      nvRecalcSoon();
    }
  });

  setTimeout(nvRecalcSticky, 800);
  setTimeout(nvRecalcSticky, 1800);
})();
/* ------------------------------------------------------------
   商品ページ / Product page — アクションボタンの多言語化
   Translate the action button labels.
   Section ファイル内の直書きテキストは LangShop が拾えないため、
   JS 辞書で置き換える。
   LangShop cannot scan hardcoded text inside section files,
   so the labels are swapped with a JS dictionary.
   ------------------------------------------------------------ */
(function () {
  var BTN = {
    ja: { reservation:'店舗で実物を見る（お取り置き）', loan:'分割払い計算', contact:'お問い合わせ',
          payLabel:'お支払方法', payCard:'クレジットカード', payLoan:'ショッピングローン', payBank:'銀行振込', payCod:'代金引換', payOther:'その他',
          skuLabel:'商品コード', priceLabel:'販売価格（税込）' },
    en: { reservation:'See it in store (hold this item)', loan:'Payment simulator', contact:'Contact us',
          payLabel:'Payment', payCard:'Credit card', payLoan:'Shopping loan', payBank:'Bank transfer', payCod:'Cash on delivery', payOther:'Other',
          skuLabel:'Item code', priceLabel:'Price (tax included)' },
    fr: { reservation:'Voir en boutique (réserver)', loan:'Simulateur de paiement', contact:'Nous contacter',
          payLabel:'Paiement', payCard:'Carte bancaire', payLoan:'Paiement échelonné', payBank:'Virement bancaire', payCod:'Paiement à la livraison', payOther:'Autres',
          skuLabel:'Référence', priceLabel:'Prix (TTC)' },
    es: { reservation:'Verlo en tienda (reservar)', loan:'Simulador de pago', contact:'Contacto',
          payLabel:'Pago', payCard:'Tarjeta de crédito', payLoan:'Pago a plazos', payBank:'Transferencia bancaria', payCod:'Contra reembolso', payOther:'Otros',
          skuLabel:'Código de artículo', priceLabel:'Precio (IVA incluido)' },
    ko: { reservation:'매장에서 실물 보기 (보관 신청)', loan:'할부 계산', contact:'문의하기',
          payLabel:'결제 방법', payCard:'신용카드', payLoan:'쇼핑 론', payBank:'계좌 이체', payCod:'대금 상환', payOther:'기타',
          skuLabel:'상품 코드', priceLabel:'판매가 (세금 포함)' },
    zh: { reservation:'到店实物查看（预留商品）', loan:'分期计算', contact:'联系我们',
          payLabel:'支付方式', payCard:'信用卡', payLoan:'分期付款', payBank:'银行转账', payCod:'货到付款', payOther:'其他',
          skuLabel:'商品编号', priceLabel:'销售价格（含税）' }
  };

  function nvTranslateButtons() {
    var code = (document.documentElement.lang || 'ja').split('-')[0].toLowerCase();
    var t = BTN[code] || BTN.ja;
    var list = document.querySelectorAll('[data-nv-btn]');
    for (var i = 0; i < list.length; i++) {
      var key = list[i].getAttribute('data-nv-btn');
      if (t[key]) { list[i].textContent = t[key]; }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nvTranslateButtons);
  } else {
    nvTranslateButtons();
  }
  document.addEventListener('shopify:section:load', nvTranslateButtons);
})();